
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';import { Subscription } from 'rxjs';

import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';
import { KeySelectItem } from '@core/models/select-item.model';
import { CoreCustomFormsService } from '@core/services/custom-forms/custom-forms.service';

import { User } from '@core/objects/user';

@Component({
    selector: 'form-field-fill-user-selector-v1',
    templateUrl: './fill-user-selector-v1.component.html'
})
export class FillUserSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Choose an user";
    public items: Array<KeySelectItem> = [];    
    public users: Array<User>;
    public selectedUserId: string; // User hash id
    public valid: boolean = false;

    private subs: Subscription[] = [];

    constructor(private customFormsSrv: CoreCustomFormsService) {}

    ngOnInit(): void {
        if( this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value != null ){
            this.selectedUserId = this.fieldSubmission.serialized_value.id;
            this.valid = true;
        }
        // inti set the default selected value
        this.emitValidity();
        this.subs.push(
            this.customFormsSrv.selectInitializedUsers().subscribe((initialized: boolean) => {
                if(!initialized){
                    this.customFormsSrv.loadUsers();
                }
            })
        );
        // this.updateMenuItems();
        this.subs.push(
            this.customFormsSrv.selectUsers().subscribe((users: User[]) => {
                if(users && users.length > 0){
                    this.users = users;
                    this.init();
                }
            })
        )
    }

    init(){
        // prepare items to view on selector.
        // const currentOptions = this.users as string[];
        this.items = this.users.map((u: User) => ({
            selected: this.fieldSubmission.serialized_value ? this.fieldSubmission.serialized_value.id.toString() === u.id.toString() : false,
            key: u.id,
            description: u.name,
            disabled: false
        }));
    }

    onSelect(userItem: KeySelectItem) {
        this.selectedUserId = userItem.key;
        this.valid = userItem && userItem !== null || !this.fieldSubmission.field.mandatory;

        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: userItem.key});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
